























































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import { Sketch } from 'vue-color';
import cloneDeep from 'lodash/cloneDeep';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';

@Component({
    components: {
        'sketch-picker': Sketch,
    },
})
export default class ProjectInfo extends Mixins(InputFieldMethods) {
    public showPrimaryColorPicker: boolean = false;
    public showSecondaryColorPicker: boolean = false;
    public primaryColor: any = '#fff';
    public secondaryColor: any = '#fff';

    public newImage: any = null;
    public mainLogo: any = null;
    public squireLogo: any = null;
    public newImagePreview: any = null;
    public mainLogoPreview: any = null;
    public squireLogoPreview: any = null;

    public projectMutable: any = null;

    constructor() {
        super();
    }

    get getCorporationsData(): any {
        return this.$store.getters['Corporations/allCorporations'];
    }

    get project() {
        return this.$store.getters['Projects/getSelectedProject'];
    }

    get hasImage() {
        return this.projectMutable !== null && this.projectMutable.image !== null;
    }

    get projectMainImagePreview() {
        if (this.hasImage && this.newImagePreview === null) {
            return `background: url(${this.projectMutable.image.base64});`;
        }

        if (this.newImagePreview !== null) {
            return `background: url(${this.newImagePreview});`;
        }

        return `background: url('/img/buildings-pexels.jpeg');`;
    }

    get projectPrimaryLogoPreview() {
        if (this.projectMutable.primaryLogo !== null && this.mainLogoPreview === null) {
            return `background: url(${this.projectMutable.primaryLogo.base64});`;
        }

        if (this.mainLogoPreview !== null) {
            return `background: url(${this.mainLogoPreview});`;
        }

        return `background: transparent;`;
    }

    get projectSquireLogoPreview() {
        if (this.projectMutable.squireLogo !== null && this.squireLogoPreview === null) {
            return `background: url(${this.projectMutable.squireLogo.base64});`;
        }

        if (this.squireLogoPreview !== null) {
            return `background: url(${this.squireLogoPreview});`;
        }

        return `background: transparent;`;
    }

    @Watch('project')
    public projectChanged() {
        if (this.project === null) {
            return;
        }

        this.projectMutable = cloneDeep(this.project);

        if (this.project.primaryColor !== null) {
            this.primaryColor = this.projectMutable.primaryColor;
        }

        if (this.project.secondaryColor !== null) {
            this.secondaryColor = this.projectMutable.secondaryColor;
        }
    }

    @Watch('primaryColor')
    public primaryColorChanged() {
        if (typeof this.primaryColor === 'object' || this.primaryColor.hasOwnProperty('hex8')) {
            this.projectMutable.primaryColor = this.primaryColor.hex8;
        }
    }

    @Watch('secondaryColor')
    public secondaryColorChanged() {
        if (typeof this.secondaryColor === 'object' || this.secondaryColor.hasOwnProperty('hex8')) {
            this.projectMutable.secondaryColor = this.secondaryColor.hex8;
        }
    }

    public readURL(file: any, previewType: any) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e: any) => {
            switch (previewType) {
                case 'image':
                    this.newImagePreview = e.target.result;
                    break;
                case 'logo':
                    this.mainLogoPreview = e.target.result;
                    break;
                case 'squire':
                    this.squireLogoPreview = e.target.result;
                    break;
            }
        };
    }

    public removeImage(type: string) {
        switch (type) {
            case 'image':

                if (this.newImage !== null) {
                    this.newImage = null;
                    this.newImagePreview = null;
                } else {
                    this.projectMutable.image = null;
                }

                break;
            case 'logo':
                if (this.mainLogo !== null) {
                    this.mainLogo = null;
                    this.mainLogoPreview = null;
                } else {
                    this.projectMutable.primaryLogo = null;
                }

                break;
            case 'squire':

                if (this.squireLogo !== null) {
                    this.squireLogo = null;
                    this.squireLogoPreview = null;
                } else {
                    this.projectMutable.squireLogo = null;
                }

                break;
        }
    }

    public changeImage(ref: any, type: string) {
        const element = (ref as HTMLInputElement);

        switch (type) {
            case 'image':
                this.newImage = (element.files.length === 0) ? null : (element.files[0] as File);
                this.readURL(this.newImage, 'image');
                break;
            case 'logo':
                this.mainLogo = (element.files.length === 0) ? null : (element.files[0] as File);
                this.readURL(this.mainLogo, 'logo');
                break;
            case 'squire':
                this.squireLogo = (element.files.length === 0) ? null : (element.files[0] as File);
                this.readURL(this.squireLogo, 'squire');
                break;
        }

        element.type = 'text';
        element.type = 'file';
    }

    public updateProject() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                this.$store.dispatch(Actions.EDIT_PROJECT, {
                    id: this.projectMutable.id,
                    name: this.projectMutable.name,
                    description: this.projectMutable.description,
                    primaryColor: this.projectMutable.primaryColor,
                    secondaryColor: this.projectMutable.secondaryColor,
                    image: this.newImage,
                    mainLogo: this.mainLogo,
                    squireLogo: this.squireLogo,
                    initialImage: this.projectMutable.image !== null,
                    initialMainLogo: this.projectMutable.primaryLogo !== null,
                    initialSquireLogo: this.projectMutable.squireLogo !== null,
                });
            }
        });
    }

    public created() {
        this.projectMutable = cloneDeep(this.project);
    }
}
